import { Box, Typography } from "@mui/material";
import Switch from "react-ios-switch";
import { setIsMapView } from "slices/searchListingReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const MapViewOption = () => {
  const dispatch = useAppDispatch();
  const { isMapView, list } = useAppSelector(
    (state) => state.searchListingReducer
  );
  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "10px",
        px: "20px",

        display: "flex",
        alignItems: "center",
        gap: "10px",
        height: "64px",
        opacity: list.length === 0 ? 0.5 : 1,
        cursor: list.length === 0 ? "block" : "pointer",
        // width: "100%",
      }}
    >
      <img
        src="/assets/img/icons/mapview.svg"
        height="24"
        width="24"
        alt="Location Search"
      />

      <Typography
        sx={{
          color: "#323232",
          fontSize: "15px",
          lineHeight: "17.66px",
          fontFamily: "gilroy-medium",
          fontWeight: 500,
        }}
      >
        Map View
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          flex: 1,
        }}
      >
        <Switch
          checked={isMapView}
          onChange={() => list.length > 0 && dispatch(setIsMapView(!isMapView))}
        />
      </Box>
    </Box>
  );
};

export default MapViewOption;
